import type { StylesConfig } from "react-select";

export type AdminHomeDropdownOption = {
  label: string;
  value: string;
};

const DROPDOWN_OPTION_HOVER_BG = "#e6e6e6";
const ADMIN_HOME_DROPDOWN_Z_INDEX = 1300;

export const adminHomeSingleDropdownStyles: StylesConfig<
  AdminHomeDropdownOption,
  false
> = {
  menuPortal: (base) => ({
    ...base,
    zIndex: ADMIN_HOME_DROPDOWN_Z_INDEX,
  }),
  menu: (base) => ({
    ...base,
    zIndex: ADMIN_HOME_DROPDOWN_Z_INDEX + 1,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused
      ? DROPDOWN_OPTION_HOVER_BG
      : state.isSelected
        ? base.backgroundColor
        : "transparent",
    color: base.color,
    ":active": {
      backgroundColor: DROPDOWN_OPTION_HOVER_BG,
    },
  }),
};

export const adminHomeMultiDropdownStyles: StylesConfig<
  AdminHomeDropdownOption,
  true
> = {
  menuPortal: (base) => ({
    ...base,
    zIndex: ADMIN_HOME_DROPDOWN_Z_INDEX,
  }),
  menu: (base) => ({
    ...base,
    zIndex: ADMIN_HOME_DROPDOWN_Z_INDEX + 1,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused
      ? DROPDOWN_OPTION_HOVER_BG
      : state.isSelected
        ? base.backgroundColor
        : "transparent",
    color: base.color,
    ":active": {
      backgroundColor: DROPDOWN_OPTION_HOVER_BG,
    },
  }),
  groupHeading: (base) => ({
    ...base,
    fontFamily: "Inter, Roboto, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    textTransform: "none",
    color: "rgba(98, 116, 142, 1)",
    marginBottom: "4px",
    paddingTop: "8px",
    paddingBottom: "4px",
  }),
};

export const adminHomeDropdownMenuPortalTarget =
  typeof document !== "undefined" ? document.body : undefined;
